import { render } from "./stronaRejestracjiBody.vue?vue&type=template&id=5e98aea0&scoped=true"
import script from "./stronaRejestracjiBody.vue?vue&type=script&lang=js"
export * from "./stronaRejestracjiBody.vue?vue&type=script&lang=js"

import "./stronaRejestracjiBody.vue?vue&type=style&index=0&id=5e98aea0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e98aea0"]])

export default __exports__